import { Box } from "@mui/material";
import { type FC } from "react";
import { EventDetails } from "../../components/event-details/EventDetails";
import { EventParticipants } from "../../components/event-participants/EventParticipants";
import { EventSideBar } from "../../components/event-sidebar/EventSidebar";
import { RelevantVolunteersSection } from "../tables/opportunities-table/RelevantVolunteersSection";
import {
  TOUR_GROUPS,
  TOUR_OPPORTUNITY,
  TOUR_VOLUNTEERS,
} from "./call-center-tour-fixtures";
import "../event-card/EventCard.scss";

export type TourMockSection = "details" | "relevant" | "participants";

async function noopRefetch() {
  return { data: undefined } as never;
}

export const CallCenterTourEventMock: FC<{ section: TourMockSection }> = ({
  section,
}) => {
  const selectedList =
    section === "participants"
      ? "add-participants"
      : section === "relevant"
        ? "relevant-volunteers"
        : "";

  return (
    <Box
      className="event-card-container event-card-embedded"
      data-tour="cc-event-card"
      sx={{ pointerEvents: "none", height: "100%" }}
    >
      <div className="event-card-header">
        <div className="titles-container">
          <p className="main">משימות</p>
          <span className="divider">»</span>
          <p data-tour="cc-event-title">{TOUR_OPPORTUNITY.title}</p>
        </div>
      </div>
      <div className="content-container">
        <EventSideBar
          eventDetails={TOUR_OPPORTUNITY}
          selectedList={selectedList}
          setSelectedList={() => undefined}
          tourAnchors
          previewMode
          onOpenPartnerOrganization={() => undefined}
        />
        <div
          className={`details-participants-container${
            selectedList === "relevant-volunteers"
              ? " event-card-relevant-volunteers-layout"
              : ""
          }`}
        >
          {selectedList !== "add-participants" && (
            <EventDetails
              displayAll
              spacious
              previewMode
              tourAnchors
              eventDetails={TOUR_OPPORTUNITY}
              onOpenPartnerOrganization={() => undefined}
            />
          )}
          {selectedList === "relevant-volunteers" && (
            <RelevantVolunteersSection
              opportunityId={TOUR_OPPORTUNITY.id}
              tourAnchors
              previewRows={TOUR_VOLUNTEERS}
            />
          )}
          {selectedList === "add-participants" && (
            <EventParticipants
              isAdd
              eventDetails={TOUR_OPPORTUNITY}
              refetchEvent={noopRefetch}
              tourAnchors
              tourShowGroups
              previewGroups={TOUR_GROUPS}
            />
          )}
        </div>
      </div>
    </Box>
  );
};
